<cb-dialog dialogHeading="{{(isEdit$ | async) ? 'Edit Question' : 'New Question'}}">
    <form class="flex-col flex"
          #form="ngForm">
        <div *cbWaitFor="mappedItem">
            <cb-select [label]="childItemLabel"
                       name="childEntityId"
                       [readonly]="isEdit$ | async"
                       [(ngModel)]="mappedItem.childEntityId"
                       [options]="childItems$ | async"
                       [required]="true">
            </cb-select>
            <div class="flex-row">
                <cb-display-value-new [value]="currentUser.profile.name"
                                      label="Current User"
                                      class="readonly-spacing">
                </cb-display-value-new>
                @if ((currentUserTeams$ | async)?.length > 1) {
                    <span
                        style="padding-top: 20px">&nbsp;&nbsp;as&nbsp;&nbsp;</span>
                }
                @if ((currentUserTeams$ | async)?.length > 1) {
                    <cb-select label="Team"
                               name="createdByTeamCode"
                               [(ngModel)]="mappedItem.createdByTeamCode"
                               [options]="currentUserTeams$ | async"
                               valueProp="key"
                               [required]="true">
                    </cb-select>
                }
            </div>
            <div class="flex-row">
                <cb-users-input-find-table class="flex flex-row"
                                           label="Question To"
                                           [(ngModel)]="recipient.id"
                                           name="recipient"
                                           [text]="recipient?.name"
                                           [removeable]="false"
                                           [required]="true">
                </cb-users-input-find-table>
                @if ((recipientTeams$ | async)?.length > 1) {
                    <span
                        style="padding-top: 20px">&nbsp;&nbsp;as&nbsp;&nbsp;</span>
                }
                @if ((recipientTeams$ | async)?.length > 1) {
                    <cb-select label="Team"
                               name="teamCode"
                               [(ngModel)]="mappedItem.teamCode"
                               valueProp="key"
                               [options]="recipientTeams$ | async"
                               [required]="true">
                    </cb-select>
                }
            </div>
            <cb-text-area label="Question"
                          name="request"
                          [required]="true"
                          [(ngModel)]="mappedItem.request"
                          [maxlength]="1024">
            </cb-text-area>
        </div>
    </form>
    <div actions class="flex flex-row center-right">
        <cb-button [disabled]="form.pristine || form.invalid"
                   [clickLimit]="1"
                   class="cb-margin-right"
                   (clicked)="save()">
            {{ (isEdit$ | async) ? 'Save' : 'Create' }}
        </cb-button>
        <cb-button (clicked)="cancel()">
            Cancel
        </cb-button>
    </div>
</cb-dialog>
